import { isEmpty } from "../../../../components/signature/signature";
import itemQuickform from "./warehousepurchase-quickform.html";

const quickformEntity = require("../../../../../production/components/quickform/quickform-entity");
const quickformHandler = require("../../../../../production/components/quickform/quickform-handler");
const { formCopy } = require("./warehousepurchase-quickform-form");
const { form } = require("./warehousepurchase-quickform-form");

/****************ELEMENTS*****************/
var htmlQf = {};
let totalItems = 0; // Variable para almacenar el total de ítems
let confirmedItems = 0; // Variable para almacenar el contador de ítems confirmados
let counterElement = null; // Variable para almacenar el elemento del contador
let confirmedItemIds = new Set();
let currentInvoiceId = null; // Variable para almacenar el ID de la factura actual
var HTMLwasSelected = false;

function HTMLselect(detail) {
  quickformHandler.HTMLselect(
    "purchase", //database table name****
    "warehousepurchase-quickform",
    detail.ev.target, //source, for example AC
    itemQuickform,
    form,
    formCopy,
    htmlQf
  );

  HTMLwasSelected = true;
} /**/

export function start(detail) {
  if (!HTMLwasSelected) {
    HTMLselect(detail);
  }

  obj[detail.act].start(detail);
}

const obj = {
  addOne: {
    start: (detail) => {
      addOne(detail, htmlQf);
    },
  },
  hide: {
    start: (detail) => {
      quickformEntity.hide(detail, htmlQf);
    },
  },
  prepareAdd: {
    start: (detail) => {
      quickformEntity.prepareAdd(detail, htmlQf);
    },
  },
  setData: {
    start: (detail) => {
      setData(detail, htmlQf);
    },
  },
  confirmPurchase: {
    start: (detail) => {
      confirmPurchase(detail, htmlQf);
    },
  },
};

export function setupItemsContainer(detail, htmlFC) {
  currentInvoiceId = htmlFC.fullcontHTML.getAttribute("data-dbid"); // Almacena el ID de la factura actual
  let data = {};
  const sourceLines = htmlFC.fullcontHTML.querySelectorAll(
    "#purchase_form_purchase_vs_item .line"
  );
  detail.act = "prepareAdd";
  start(detail);
  totalItems = sourceLines.length;
  // Generar claves únicas para localStorage
  const confirmedItemsKey = `confirmedItems_${currentInvoiceId}`;
  const confirmedItemIdsKey = `confirmedItemIds_${currentInvoiceId}`;

  confirmedItems = parseInt(localStorage.getItem(confirmedItemsKey)) || 0;
  const savedItemIds =
    JSON.parse(localStorage.getItem(confirmedItemIdsKey)) || [];
  confirmedItemIds = new Set(savedItemIds);

  // Seleccionar el div existente
  counterElement = htmlQf.quickformHTML.querySelector(
    ".confirm-counter.confirm-warehousepurchase"
  );

  if (!counterElement) {
    console.log(
      "Error: Elemento .confirm-counter.confirm-warehousepurchase no encontrado."
    );
    return; // Salir si el elemento no se encuentra
  }
  updateCounterDisplay();
  const targetContainer = htmlQf.quickformHTML.querySelector(
    "#purchase_form_purchase_vs_item_2"
  );
  targetContainer.innerHTML = "";

  sourceLines.forEach((line) => {
    const clonedLine = line.cloneNode(true);
    const row = clonedLine.querySelector(".warehousepurchase-row");

    const itemIdDiv = clonedLine.querySelector(".item_id");
    const itemQtyDiv = clonedLine.querySelector(".qty");
    let qty = itemQtyDiv.querySelector(".elem").value;
    const otherField = itemIdDiv.querySelector(".otherField");
    data = {
      data: otherField
        ? JSON.parse(otherField.getAttribute("otherfield"))
        : null,
    };
    let id = data.data.id;
    let name = data.data.name;

    row.setAttribute(
      "data-detail",
      `{"click": [ {"dest":"ripple" }, {"dest":"warehousepurchase", "elem":"quickform", "act":"setData", "id":"${id}", "name":"${name}", "qty":"${qty}" } ] }`
    );
    const chip = itemIdDiv.querySelector(".chip");

    if (chip) {
      const removeSpan = chip.querySelector('span[title="Remove"]');

      if (removeSpan) {
        removeSpan.remove(); // Remueve el span usando remove()
      } else {
        console.log("Elemento 'Remove' no encontrado en el chip.");
      }
    } else {
      console.log("Chip no encontrado en item_id.");
    }
    targetContainer.appendChild(clonedLine);
  });
}

function updateCounterDisplay() {
  if (counterElement) {
    counterElement.textContent = `${confirmedItems}/${totalItems}`;
  }
  const confirmedItemsKey = `confirmedItems_${currentInvoiceId}`;
  localStorage.setItem(confirmedItemsKey, confirmedItems.toString());
}

function setData(detail, htmlQf) {
  let input = htmlQf.quickformHTML.querySelector("#confirmInputPurchase");
  if (input) {
    input.value = detail.name + " " + detail.qty;
    input.setAttribute(
      "data-detail",
      `{"key": [ {"dest":"ripple" }, {"dest":"warehousepurchase", "elem":"quickform", "act":"confirmPurchase", "id":"${detail.id}", "name":"${detail.name}", "qty":"${detail.qty}" } ] }`
    );
  } else {
    console.log("Error: Input #confirmInputPurchase no encontrado.");
  }
}

function confirmPurchase(detail, htmlQf) {
  let id = detail.id;
  const purchaseForm = htmlQf.quickformHTML.querySelector(
    "#purchase_form_purchase_vs_item_2"
  );

  if (purchaseForm) {
    const lines = purchaseForm.querySelectorAll(".line");
    const confirmedLine = Array.from(lines).find((line) => {
      const itemIdDiv = line.querySelector(".item_id");
      if (!itemIdDiv) return false;

      const otherField = itemIdDiv.querySelector(".otherField");
      if (!otherField) return false;

      try {
        const otherFieldData = JSON.parse(
          otherField.getAttribute("otherfield")
        );
        if (!otherFieldData || typeof otherFieldData.id === "undefined")
          return false;

        const parsedOtherFieldDataId = parseInt(otherFieldData.id);
        const parsedId = parseInt(id);

        if (isNaN(parsedOtherFieldDataId) || isNaN(parsedId)) {
          console.log("Error: No se pudo parsear el ID.");
          return false;
        }

        const match = parsedOtherFieldDataId === parsedId;
        console.log(`Comparación ID ${otherFieldData.id} con ${id}: ${match}`);
        return match;
      } catch (error) {
        console.error("Error al parsear otherfield:", error);
        return false;
      }
    });

    if (!confirmedLine) {
      console.log(`Ítem con ID ${id} no encontrado.`);
      return;
    }

    if (confirmedItemIds.has(id)) {
      console.log(`Ítem con ID ${id} ya confirmado.`);
      return;
    }

    confirmedItemIds.add(id);
    const confirmedItemIdsKey = `confirmedItemIds_${currentInvoiceId}`;
    localStorage.setItem(
      confirmedItemIdsKey,
      JSON.stringify(Array.from(confirmedItemIds))
    );

    if (confirmedItems < totalItems) {
      confirmedItems++;
      updateCounterDisplay();
    }
  } else {
    console.log("Elemento #purchase_form_purchase_vs_item_2 no encontrado.");
  }
}

function addOne(detail, htmlQf) {
  quickformEntity.addOne(detail, htmlQf);
}
